module.exports = __webpack_public_path__ + "static/media/Elizabeth_Kim_DDS.8a4e2b46.png";